// src/.umi-production/core/loaders.ts
var loaders_default = {};
export {
  loaders_default as default
};
